import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=18e6e905&scoped=true"
import script from "./LabelList.vue?vue&type=script&lang=ts"
export * from "./LabelList.vue?vue&type=script&lang=ts"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=18e6e905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e6e905",
  null
  
)

export default component.exports